import useSWR from 'swr';
import { companySettingsKeyType, customSWRConfig, customSWRResponse, ISingleCompanySetting } from '../../model/types';
import { nonNullishValue } from '../../utils/helpers';
import useSWRCacheKeys from '../useSWRCacheKeys';

// TODO: think whether to use via useCompanySettings hook?
export default function useSingleCompanySetting<T extends companySettingsKeyType>(
    settingKey: T,
    config: customSWRConfig = {}
): customSWRResponse<ISingleCompanySetting<T>> {
    const keys = useSWRCacheKeys(nonNullishValue(settingKey) ? `/settings/${settingKey}` : null);

    return useSWR<ISingleCompanySetting<T>>(keys, { ...config });
}
